import { EnumHelper } from '~/utils/EnumHelper';
import { useAppSelector } from '../useAppSelector';
import useLoading from '../useLoading';
import { UserProfession, UserSubProfession } from '~/enums/UserProfession';
import { useEffect, useMemo } from 'react';
import { filterObjectKeys } from '~/utils/Object';
import { useDispatch } from 'react-redux';
import { getUserEducation } from '~/actions';

export const useSpecialtyOptions = (profession: string) => {
  const dispatch = useDispatch();

  const educations = useAppSelector((state) => state.user.userEducation);
  const { isLoading } = useLoading(['GET_USER_EDUCATION_ACTION']);

  useEffect(() => {
    if (profession) {
      const professionCode = UserProfession.getNormalizedCode(profession);
      dispatch(getUserEducation({ profession: professionCode }));
    }
  }, [dispatch, profession]);

  const options = useMemo(() => {
    if (!profession || !educations) {
      return [];
    }

    const isSubProfession = EnumHelper.getObjectKeys(UserSubProfession).includes(profession);
    const professionCode = isSubProfession
      ? UserSubProfession.getProfession(profession)
      : profession;
    const normalizedProfessionCode = UserProfession.getNormalizedCode(professionCode || '');
    const specialtiesAndProcedures =
      // @ts-expect-error - not typed
      educations?.[normalizedProfessionCode]?.specialtiesAndProcedures;

    if (!specialtiesAndProcedures) {
      return [];
    }

    const filteredSpecialties = filterObjectKeys(specialtiesAndProcedures, 'specialty');
    const specialtyKeys = Object.keys(filteredSpecialties);

    return specialtyKeys.map((key) => ({
      title: key.split('_')?.[1] || 'General',
      value: key,
    }));
  }, [profession, educations]);

  return { isLoading, options };
};
